export default __webpack_public_path__ + "static/media/regulatory--except-railroad-crossing--g1.eacd41fa.png";